import React from 'react';
import './About.css';
import { useNavigate } from 'react-router-dom';

// Then, inside your component function, add this before the return statement:

const About = () => {
    const navigate = useNavigate();

    // Replace your current handleButtonClick function with this:
    const handleButtonClick = () => {
        navigate('/contact');
    };
    return (
        <>
            <section id='about-us' className='about-section'>
                <div className='decorative-shapes'>
                    <div className='shape circle-1'></div>
                    <div className='shape circle-2'></div>
                    <div className='shape circle-3'></div>
                    <div className='shape circle-4'></div>
                    <div className='shape circle-5'></div>
                    <div className='shape circle-6'></div>
                    <div className='shape circle-7'></div>
                    <div className='shape circle-8'></div>
                </div>
                <div className='about-container'>
                    <div className='about-images'>
                        <div className='main-image'>
                            <img src='clinic.jpg' alt='Dental Office' />
                        </div>
                        <div className='overlay-image'>
                            <img src='DrMuskan.jpeg' alt='Dental Team' />
                        </div>
                    </div>

                    <div className='about-content'>
                        <span className='about-subtitle'>ABOUT US</span>
                        <h3 className='about-title'>Welcome To Wisdom Dental Clinic</h3>

                        <p className='about-description'>
                            Our clients are our priority, we offer quality dental services with a team of specialists.
                        </p>

                        <p className='about-text'>
                            <b>Dr. Muskan – Your Trusted Dental Expert</b>
                        </p>

                        <p className='about-text'>
                            With years of experience in dentistry, Dr. Muskan ensures every patient receives top-notch care. She specializes
                            in cosmetic and restorative dentistry, transforming smiles with precision and care.
                        </p>

                        <button className='appointment-btn' onClick={handleButtonClick}>
                            Book an Appointment
                        </button>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
